@if (price > 0) {
    <div class="grid-container p-12:b md:p-16:b lg:p-24:b product-price-display">
        <div class="g-12 md:g-6">
            <label>Dein Beitrag:</label>
        </div>
        <div class="g-12 md:g-6 align:r">
            <span class="h4 product-hint">{{ settlementPeriod === 'year' ? 'Jährlich' : 'Monatlich' }}</span>
            <app-display-price [price]="price"></app-display-price>
            <span
                class="product-tax-details"
                [innerHTML]="taxInfo"
            ></span>
        </div>
    </div>
}
